<template>
  <div class="signup">
    <SignUpHero />
    <SignUpContainer />
  </div>
</template>

<script>

export default {
  name: 'Signup'
}
</script>

<style lang="scss" scoped>
.signup {
  overflow-x: hidden;
  margin-bottom: 2rem;
  @media ($screen-md) {
    padding: 0 2rem;
  }
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
}
</style>
